import React from 'react'
import Home from '../../home/Home'
import AccountBilling from '../../account-billing/AccountBilling'

const AccountBillingView = () => {
  return (
    <>
    <Home/>
    <AccountBilling />
    </>
  )
}

export default AccountBillingView
